import { render, staticRenderFns } from "./StepsHeader.vue?vue&type=template&id=55c44ae8&scoped=true"
import script from "./StepsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StepsHeader.vue?vue&type=style&index=0&id=55c44ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c44ae8",
  null
  
)

export default component.exports